(function () {

 'use strict';

  angular.module('eclipseApp.core').filter('accountOverviewCTN', function() {
    return function (ctn) {
      if (!ctn) { return ''; }

      var value = ctn.toString().trim().replace(/^\+/, '');

      if (value.match(/[^0-9]/)) {
        return ctn;
      }

      var numberOne, numberTwo;

      switch (value.length) {
        case 10:
          numberOne = value.slice(0, 3);
          numberTwo = value.slice(3);
          break;
        default:
          return ctn;
      }

      numberTwo = numberTwo.slice(0, 3) + '-' + numberTwo.slice(3);

      return (numberOne + '-' + numberTwo).trim();
    };

  });

})();

